import { render, staticRenderFns } from "./complaintStatistics.vue?vue&type=template&id=35f1bf92&scoped=true"
import script from "./complaintStatistics.vue?vue&type=script&lang=js"
export * from "./complaintStatistics.vue?vue&type=script&lang=js"
import style0 from "./complaintStatistics.vue?vue&type=style&index=0&id=35f1bf92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f1bf92",
  null
  
)

export default component.exports